import DatePick_MI from 'components/DatePicker_MI'
import React, { useContext, useState } from 'react'

const RequestedCoverageEffDate = ({ requestContext, vehicleContext }) => {
    const requestTypeContext = useContext(requestContext)
    const newVehicleContext = useContext(vehicleContext)
    const [requestedCovEffDate, setRequestedCovEffDate] = useState(requestTypeContext.getTodaysDate(true))

    return (
        <>
            {/* Requested Effective Date */}
            <div className='col-xl-12 justify-content-center' style={{ margin: "0 0.5rem", padding: "0 0.75rem" }}>
                <div className="row form-group form-group-sm align-items-center my-3">
                    <div className="col-12 col-md-6 text-primary fw-bold mb-2 mb-md-0 fs-6">
                        Requested Coverage Effective Date*
                    </div>
                    <div className="col-12 col-md-6 col-sm-8">
                        <DatePick_MI
                            dateSubmit={newVehicleContext.newVehicle.requestedCovEffDate ? newVehicleContext.newVehicle.requestedCovEffDate : requestedCovEffDate}
                            setDateSubmit={setRequestedCovEffDate}
                            storeValue={newVehicleContext.newVehCallback}
                            nameValue={"requestedCovEffDate"}
                            displayCalendar={"bottom-start"}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default RequestedCoverageEffDate